import { gql } from "graphql-tag";

export const INVOICE_FIELDS = gql`
  fragment CustomerFields on Customer {
    id
    uuid
    path
    user {
      id
      uuid
      name
      email
      status

      image {
        id
        file_path

      }
    }
    invoices {
      customer_id
      id
      created_at
      modified_date
    }

  }
`;

export const CUSTOMER_FIELDS = gql`
  fragment CustomerFields on Customer {
    id
    uuid
    path
    user {
      id
      uuid
      name
      email
      status

      image {
        id
        file_path

      }
    }
    orders {
      customer_id
      id
      uuid
      created_at
    }

  }
`;

export const CUSTOMER_PAYMENT_FIELDS = gql`
  fragment CustomerFields on Customer {
    id
    uuid
    user {
      id
      uuid
      name
      email
      status
    }
    orders {
      customer_id
      currency
      id
      uuid
      created_at
      order_total{
        id
        reference_id
        title
        code
        value
        
      }
      order_payment{
        id
        order_id
        price
        transaction_id
        status
        payment_method_id
        payment_method{
          id
          name
        }
      }
    }

  }
`;

export const PAGINATION = gql`
  fragment Pagination on CustomerPagination {
    total
    per_page
    current_page
    from
    to
    last_page
    has_more_pages
  }
`;

export const ORDER_PAYMENT_FIELDS = gql`
    fragment OrderPayment on OrderPayment {
        id
        order_id
        price
        transaction_id
        created_at
        status
        path
        payment_method_id
        payment_method {
            id
            name
        }
        order{
            id
            uuid
            customer_id
            created_at
            currency
            customer{
                id
                user_id
                uuid
                user{
                    id
                    uuid
                    name
                    email
                }
                
            }
            order_total{
                id
                reference_id
                title
                code
                value
            }
            country{
                id
                name
            }
        }
    }
`;

export const ORDER_PAYMENT_PAGINATION = gql`
    fragment OrderPaymentPagination on OrderPaymentPagination {
        total
        per_page
        current_page
        last_page
        from
        to
    }
`;

export default { CUSTOMER_FIELDS, PAGINATION, INVOICE_FIELDS, CUSTOMER_PAYMENT_FIELDS, ORDER_PAYMENT_FIELDS, ORDER_PAYMENT_PAGINATION };